// extracted by mini-css-extract-plugin
export default {"main":"background_main__R7k68","content":"background_content__i2Ksa","dark":"background_dark__P15Yp"};